/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum ImageSize {
    PREVIEW = 'Preview',
    ORIGINAL = 'Original',
}
